module.exports = {
	"data": {
		"postBySlug": {
			"html": "<h1 id=\"subtitle\"><a href=\"#subtitle\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Subtitle</h1>\n<p>There is much here</p>",
			"frontmatter": {
				"title": "Doc2 and more"
			},
			"fields": {
				"slug": "/doc-2-and-more"
			}
		}
	},
	"pathContext": {
		"slug": "/doc-2-and-more"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/doc-2-and-more.json
// module id = 459
// module chunks = 26055137832174